import actions from "./actions";

const initState = {
    items: [],
    lastId: undefined,
    unreadCount: 0,
    hasMore: true,
    readAllState: false,
    dropdownVisible: false,
    modalVisible: false,
    notification: {},
    shouldOpenPopoverOnClose: true,
};
let items;
export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.NOTIFICATION_ON_CREATED: {
            // Check if the new id exists already
            const { notification } = action;
            items = [...state.items];
            const findIndex = items.findIndex(i => i.id === notification.id);
            if (findIndex >= 0)
                items[findIndex] = notification;

            else
                items.push(notification);

            items = items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            return {
                ...state,
                items,
                unreadCount: (state.unreadCount + 1) || 0,
            };
        }
        case actions.NOTIFICATION_ON_READ: {
            return {
                ...state,
                items: state.items.map(item => ({
                    ...item,
                    is_read: true,
                })),
                unreadCount: 0,
            };
        }
        case actions.NOTIFICATION_READ_REQUEST:
            return {...state, readAllState: "request"};

        case actions.NOTIFICATION_READ_SUCCESS: {
            items = [...state.items];
            action.notifications.forEach(newData => {
                const findIndex = items.findIndex(i => i.id === newData.id);
                if (findIndex < 0)
                    items.push(newData);
            });
            items = items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            return {
                ...state,
                readAllState: 'success',
                hasMore: !action.is_last,
                items,
                lastId: (items.length) ? items[items.length - 1].id : undefined,
                unreadCount: action.unreadCount,
            };
        }
        case actions.NOTIFICATION_READ_ERROR:
            return {...state, readAllState: false};

        case actions.NOTIFICATION_OPEN_DROPDOWN:
            return {
                ...state,
                dropdownVisible: true,
            };
        case actions.NOTIFICATION_CLOSE_DROPDOWN:
            return {
                ...state,
                dropdownVisible: false,
            };
        case actions.NOTIFICATION_OPEN_MODAL:
            return {
                ...state,
                modalVisible: true,
                notification: action.notification,
                shouldOpenPopoverOnClose: action.shouldOpenPopoverOnClose,
            };
        case actions.NOTIFICATION_CLOSE_MODAL:
            return {
                ...state,
                modalVisible: false,
                notification: {},
            };
        case actions.NOTIFICATION_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
